import { render, staticRenderFns } from "./ModalValorDiferenciadoBaseNacional.vue?vue&type=template&id=fdbf3712&scoped=true&"
import script from "./ModalValorDiferenciadoBaseNacional.vue?vue&type=script&lang=js&"
export * from "./ModalValorDiferenciadoBaseNacional.vue?vue&type=script&lang=js&"
import style0 from "./ModalValorDiferenciadoBaseNacional.vue?vue&type=style&index=0&id=fdbf3712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbf3712",
  null
  
)

export default component.exports